
import Vue from "vue";

interface NavLink {
  icon: string;
  text: string;
  route: { name: string };
  visibility: (ctx: { hasLimitedAccess: boolean }) => boolean;
}

export default Vue.extend({
  name: "NavigationMenu",

  computed: {
    hasLimitedAccess(): boolean {
      return this.$store.state.user.has_limited_data_access;
    },

    visibleLinks(): NavLink[] {
      return this.links.filter((link) =>
        link.visibility({ hasLimitedAccess: this.hasLimitedAccess })
      );
    },
  },

  data(): { links: NavLink[] } {
    return {
      links: [
        {
          icon: "mdi-view-dashboard",
          text: "Dashboard",
          route: { name: "home" },
          visibility: () => true, // visibile a tutti
        },
        {
          icon: "mdi-google-maps",
          text: "Mappa",
          route: { name: "map" },
          visibility: () => true,
        },
        {
          icon: "mdi-alarm-light",
          text: "Allarmi",
          route: { name: "alarmGraph" },
          visibility: ({ hasLimitedAccess }) => !hasLimitedAccess,
        },
        {
          icon: "mdi-truck-fast",
          text: "Veicoli",
          route: { name: "vehicleList" },
          visibility: ({ hasLimitedAccess }) => !hasLimitedAccess,
        },
        {
          icon: "mdi-transit-connection-horizontal",
          text: "Dispositivi",
          route: { name: "deviceHistoryList" },
          visibility: ({ hasLimitedAccess }) => !hasLimitedAccess,
        },
        {
          icon: "mdi-account",
          text: "Profilo",
          route: { name: "profile" },
          visibility: () => true, // visibile a tutti
        },
      ],
    };
  },
});
